module.exports = __webpack_public_path__ + "static/10-a12135adcc2028c8c73ccf47754472f0.jpg";